/*eslint no-unused-vars:0 */
import $ from "jquery";
import "magnific-popup/dist/jquery.magnific-popup";
import "stacktable.js/stacktable";
import * as ko from "knockout";
import flatpickr from "flatpickr";
import { debounce } from "underscore";
import contactAppointmentMehtods from "../modules/contact-appointment-methods";

export default {
  init() {
    // Initializing the popups
    $(".single_product_button_group_1 .description").magnificPopup({
      type: "inline",
    });
    $(".single_product_button_group_1 .shipping_info").magnificPopup({
      type: "inline",
    });
    $(".single_product_button_group_2 .quantity").magnificPopup({
      type: "inline",
    });

    // Syncing the quantity input in the modal
    // quantityInput = .single-product .quantity .input-text.qty.text
    // modalQuantityInput = #modal_quantity_input
    const quantityInputSelector = ".woocommerce .quantity .input-text.qty.text";
    const modalQuantityInput = "#modal_quantity_input";
    const currentValueTag = "#currently_selected_quantity";

    $(quantityInputSelector).addClass("hide");

    $(currentValueTag).text($(quantityInputSelector).val());
    $(modalQuantityInput).val($(quantityInputSelector).val());
    $(quantityInputSelector + ", " + modalQuantityInput).on(
      "change",
      function () {
        $(quantityInputSelector + ", " + modalQuantityInput).val(this.value);
        $(currentValueTag).text(this.value);
      }
    );

    if ($("body").hasClass("variable-product")) {
      this.variableProductCode();
    }

    if ($(".make-appointment").length > 0) {
      this.appointmentOnlyCode();
    }
    // if ($('body').hasClass('appointment_only')) {
    //   this.appointmentOnlyCode();
    // }

    // show instagram feed at the bottom
    // this.instafeed();
    this.repositionBookAppointmentModal();

  },
  variableProductCode() {
    // initialize pop up
    $(".single_product_button_group_2 .size").magnificPopup({
      type: "inline",
    });
    // initialize the size_table responsive features
    // if the product is variable and based on the type of sizing the product has, hide on table or the other

    // Added a try/catch block to prevent an error that was preventing the user from picking a size with the size watches.
    try {
      if (
        document.querySelector("body").classList.contains("variable-product")
      ) {
        let numberSelector = document.getElementById("pa_numbered-sizes");
        let letterSelector = document.getElementById("pa_size");

        let numberSizeTable = document.getElementById("number_table");
        let letterSizeTable = document.getElementById("size_table");
        if (letterSelector) {
          //  hide the number sizing table
          numberSizeTable.style.display = "none";
          $("#size_table").stacktable();
        } else if (numberSelector) {
          // hide the letter sizing table
          letterSizeTable.style.display = "none";
          $("#number_table").stacktable();
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("Stacktable relatedror error", error);
    }

    // Custom Size Modal and Button
    // define variables
    const numberedSizesDropdown = document.getElementById("pa_numbered-sizes");
    const customSizePopupButton = document.querySelector(
      ".single_product_button_group_3 .custom-size"
    );
    const okButton = document.getElementById("ok-button");
    // initialize the pop up
    $(customSizePopupButton).magnificPopup({
      type: "inline",
    });
    // hide it at first
    $(customSizePopupButton).hide();

    // if custom is the dropdown item pre-selected, show up the button
    if (numberedSizesDropdown) {
      if (numberedSizesDropdown.value == "custom") {
        $(customSizePopupButton).show();
      }
      numberedSizesDropdown.addEventListener("change", (event) => {
        if (event.target.value == "custom") {
          $(customSizePopupButton).show();
        } else {
          $(customSizePopupButton).hide();
        }
      });
    }

    // add the event listener so it only shows up when the value is custom

    // add event listener to close the pop up when ok-button is pressed
    if (okButton) {
      okButton.addEventListener("click", (event) => {
        // apparently every button inside a form triggers the submit event when clicked upon
        event.preventDefault();
        $(customSizePopupButton).magnificPopup("close");
      });
    }

    // add event listener to the OK button to close the pop up
  },
  appointmentOnlyCode() {
    // initialize the pop up
    $(".make-appointment").magnificPopup({
      type: "inline",
    });

    ko.bindingHandlers.captureEvent = {
      init: (element, valueAccesor) => {
        let arg = valueAccesor();
        for (let eventName in arg) {
          element.addEventListener(eventName, arg[eventName], true);
        }
      },
    };
    ko.applyBindings(
      new AppointmentViewModel(),
      document.querySelector("#single-product-appointment ")
    );
    flatpickr("#calendar", {
      dateFormat: "F d, Y",
      disable: [
        function (date) {
          return date.getDay() == 1;
        },
      ],
      onChange: function (selectedDates, dateStr, instance) {
        let day = instance.parseDate(dateStr).getUTCDay();
        const sundayTimes = ["", "11AM", "12PM", "1PM", "2PM", "3PM"];
        const regularDayTimes = [
          "",
          "11AM",
          "12PM",
          "1PM",
          "2PM",
          "3PM",
          "4PM",
          "5PM",
          "6PM",
        ];
        let timeSelect = document.querySelector(
          '#single-product-appointment select[name="appointment_time"]'
        );
        // i.e. its sunday
        if (day == 0) {
          // clean all the optoins
          while (timeSelect.firstChild) {
            timeSelect.removeChild(timeSelect.firstChild);
          }
          sundayTimes.forEach((el) => {
            let option = document.createElement("option");
            option.setAttribute("value", el);
            option.textContent = el;
            timeSelect.appendChild(option);
          });
        } else {
          // clean all the options
          while (timeSelect.firstChild) {
            timeSelect.removeChild(timeSelect.firstChild);
          }
          regularDayTimes.forEach((el) => {
            let option = document.createElement("option");
            option.setAttribute("value", el);
            option.textContent = el;
            timeSelect.appendChild(option);
          });
        }
      },
    });
  },
  repositionBookAppointmentModal() {
    /**
     * After a shortcode [appointment_modal] was added
     * we wanted to reposition it so it shows up under the
     * "add to cart" button. This script is an attempt to
     * reposition it with JavaScript if the button has the
     * class reposition.
     */

    const bookAppointmentButton = document.querySelector(
      "button.make-appointment.reposition"
    );
    const seeMoreText = document.querySelector(".c-see-more");

    if (bookAppointmentButton && seeMoreText) {
      seeMoreText.parentNode.insertBefore(bookAppointmentButton, seeMoreText);
    }

  }
  // instafeed() {
  //   /*====================================
  //   Instagram Feed
  //   =======================================*/
  //   let feedContainer = document.getElementById("instafeed");
  //   if (feedContainer) {
  //     let feed = new Instafeed({
  //       get: "user",
  //       userId: "398168561",
  //       accessToken: "398168561.a038f87.c96dda2ae11740da99100845373ac2a5",
  //       links: true,
  //       limit: 6,
  //       resolution: "low_resolution",
  //     });
  //     feed.run();
  //   }
  // },
};

function AppointmentViewModel() {
  this.personalData = {
    firstName: ko.observable(""),
    lastName: ko.observable(""),
    fullName: ko.pureComputed(
      () => this.personalData.firstName() + " " + this.personalData.lastName()
    ),
    phoneNumber: ko.observable(""),
    email: ko.observable(""),
  };
  this.appointmentData = {
    appointmentLength: ko.observable(""),
    appointmentDate: ko.observable(""),
    appointmentTime: ko.observable(""),
    consultationInfo: ko.pureComputed(() => {
      return this.appointmentData.appointmentLength() !== "" &&
        this.appointmentData.appointmentDate() !== ""
        ? this.appointmentData.appointmentLength() +
            ", " +
            this.appointmentData.appointmentDate()
        : "";
    }),
    appointmentPurpose: ko.observable(""),
    customAppointmentPurpose: ko.observable(""),
  };

  // checking if other is selected in Appointment Purpose
  // bind the value the display property of the custom purpose input field to a function that compares the value of appointmentPurpose and if its == to 'other' and returns true, if not, returns false and the input field is not shown

  // // step manager code

  this.insertLoadingIcon = (selector) => {
    // Removing the make appointment button with animate.css event and then setting display: none
    const elementToReplace = document.querySelector(selector);
    elementToReplace.addEventListener("animationend", (e) =>
      e.target.classList.add("hide")
    );
    elementToReplace.classList.add("animated", "faster", "fadeOut");

    // Adding the loader svg. The paths.dist is a global variable provided by a localized script in setup.php
    let loader = document.createElement("img");
    // eslint-disable-next-line no-undef
    loader.src =
      "https://glaudicollection.com/wp-content/themes/sage-woo/resources/assets/images/icons/loader.svg";
    loader.classList.add("loader", "animated", "fadeIn");
    loader.style.cssText += ";" + "width:60px;height:60px;";
    elementToReplace.parentNode.appendChild(loader);
  };
  this.insertFetchResponse = (selector, message) => {
    let element = document.querySelector(selector);
    element.classList.add("hide");
    let result = document.createElement("p");
    result.classList.add("text-serif", "text-md");
    result.innerText = message;
    element.parentNode.appendChild(result);
  };
  this.inputValidation = debounce((event) => {
    const element = event.target;
    const isValid = element.checkValidity();
    if (isValid) {
      element.classList.add("valid");
      element.classList.remove("invalid");
    } else {
      element.classList.remove("valid");
      element.classList.add("invalid");
      element.reportValidity();
    }
  }, 200);
  this.formValidation = debounce((event) => {
    // const element = event.target;
    // const parentFieldset = element.closest('fieldset');
    // const fieldsets = document.querySelectorAll('fieldset');
    // let errorStep = Array.prototype.indexOf.call(fieldsets, parentFieldset);
    // this.goToStep(errorStep);
  });

  // Create Appointment sends a POST request to create the appointment which is handled by a custom AJAX endpooint
  this.createAppointment = (formElement) => {
    this.insertLoadingIcon(".action-buttons .submit");
    let form = new FormData(formElement);
    form.append("action", "create_appointment");
    // eslint-disable-next-line no-undef
    if (ajaxSettings) {
      // eslint-disable-next-line no-undef
      fetch(ajaxSettings.ajaxurl, {
        method: "POST",
        headers: {
          "Cache-Control": "no-cache",
        },
        body: form,
      })
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(response.statusText);
          }
          return response.text();
        })
        .then(
          (data) => {
            // this.insertFetchResponse('.action-buttons .loader', data);
            let baseUrl = window.location.origin;
            window.location = baseUrl + "/appointment-set";
          },
          (err) => {
            this.insertFetchResponse(
              ".action-buttons .loader",
              "Sorry! Apparently there was a problem when creating the appointment. Send us an email or gives us a call to set up the appoinment!"
            );
          }
        );
    }
  };
  // this function shows up the 'other purpose' text input when needed. The function is bind from the front-end html
  this.appointmentMethods = contactAppointmentMehtods;
}



// WEBPACK FOOTER //
// ./scripts/routes/singleproduct.js